<template>
  <div class="float-summary fixed top-44 right-3 z-50">
    <transition
      name="scale"
      enter-class="scale-0 opacity-0"
      enter-to-class="scale-100 opacity-100 duration-500"
      leave-class="scale-100 opacity-100"
      leave-to-class="scale-0 opacity-0 duration-300"
    >
      <VSummaryFloat v-if="open" :content="content" :title="title" @click="onToggle"></VSummaryFloat>
    </transition>
    <button
      @click="onToggle"
      aria-label="Open Summary"
      class="relative text-white w-12 md:w-14 p-3 transition-all group"
    >
      <span
        class="absolute inset-0 bg-gradient-to-bl from-blue-500 to-purple-600 rounded-full"
      ></span>
      <i v-icon:shine-star class="relative"></i>
    </button>
  </div>
</template>
<script>
import VSummaryFloat from "./VSummaryFloat.vue";
export default {
  name: "VSummary",
  props: {
    content: {
      type: String,
      default: "",
    },
    title: {
      type: String,
      default: "",
    },
  },
  components: {
    VSummaryFloat,
  },
  data() {
    return {
      open: false,
    };
  },
  methods: {
    onToggle() {
      this.open = !this.open;
    },
  },
};
</script>
<style>
/* width */
.float-summary ::-webkit-scrollbar {
  @apply w-2;
}

/* Track */
.float-summary ::-webkit-scrollbar-track {
  @apply bg-gray-200 rounded-full;
}

/* Handle */
.float-summary ::-webkit-scrollbar-thumb {
  @apply bg-gray-400 rounded-full;
}

/* Handle on hover */
.float-summary ::-webkit-scrollbar-thumb:hover {
  @apply bg-gray-500;
}
</style>
